<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5489 5L21.5 11.9755L14.5 19" stroke="#8C96B4" stroke-width="2" stroke-linecap="round" />
    <path d="M3 12H20.5" stroke="#8C96B4" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      currentColor: '#D7DCE6',
    };
  },
  props: {
    width: {
      type: String,
      default: '0.12rem',
    },
    height: {
      type: String,
      default: '0.12rem',
    },
  },
  computed: {},
  components: {},
};
</script>
<style lang="scss" scoped></style>
